import React from 'react';
import withIcon from '../utilities/withIcon';

const IconTag = () => {
  return (
    <g>
      <path d="m15.7124.2871a.75.75 0 0 0 -1.0605 0l-1.4839 1.4839-.708-.7075a.7515.7515 0 0 0 -.51-.22l-4.1546-.116a.8061.8061 0 0 0 -.5508.22l-6.957 6.9558a.75.75 0 0 0 0 1.0606l6.7481 6.749a.75.75 0 0 0 1.0605 0l6.957-6.957a.75.75 0 0 0 .22-.5508l-.1165-4.1551a.7515.7515 0 0 0 -.22-.51l-.7085-.7085 1.4839-1.4839a.75.75 0 0 0 .0003-1.0605zm-2.0469 4.1029.0986 3.5342-6.1982 6.1979-5.6875-5.6885 6.1983-6.1973 3.5342.0986.4966.4966-.7216.7216a2.2343 2.2343 0 1 0 1.061 1.06l.7211-.7211zm-2.7109.6563a.7368.7368 0 1 1 -.52-.2139.7338.7338 0 0 1 .52.2135z" />
    </g>
  );
};

export default withIcon(IconTag);
